import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { DURCHFUEHRUNG_PATH } from '@mcikm-vote/shared';
import type { Durchfuehrungsstand } from '@mcikm-vote/shared';

import { apiAnfrage } from '../api/anfrage';
import type { ApiFehler } from '../api/anfrage';

/**
 * Der Durchführungsstand für Dashboard und Live-Ansicht (§20.2, §20.3).
 *
 * Eine Abfrage für beide Ansichten. Sie enthält keine Stimmenverteilung — der Antworttyp hat dafür
 * kein Feld (§16).
 */

export const DURCHFUEHRUNG_SCHLUESSEL = ['admin', 'durchfuehrung'] as const;

/**
 * Rückfalltakt ohne Echtzeitkanal.
 *
 * Serverseitig mit `@OhneAktivitaet()`: Die Abfrage verlängert die 30-Minuten-Frist nicht (§5.2).
 * Mit stehendem Kanal genügt ein deutlich größerer Abstand, weil jede Änderung ohnehin einen
 * Anstoß auslöst — das Polling bleibt trotzdem bestehen (§22.2).
 */
export const DURCHFUEHRUNG_ABSTAND_MS = 3_000;
export const DURCHFUEHRUNG_ABSTAND_ECHTZEIT_MS = 20_000;

export function useDurchfuehrung(
  echtzeitVerbunden = false,
): UseQueryResult<Durchfuehrungsstand, ApiFehler> {
  return useQuery<Durchfuehrungsstand, ApiFehler>({
    queryKey: DURCHFUEHRUNG_SCHLUESSEL,
    queryFn: () => apiAnfrage<Durchfuehrungsstand>(DURCHFUEHRUNG_PATH),
    refetchInterval: echtzeitVerbunden
      ? DURCHFUEHRUNG_ABSTAND_ECHTZEIT_MS
      : DURCHFUEHRUNG_ABSTAND_MS,
  });
}
